// validate account Id
export const validateAccountId = val => /^\d{1,12}$/g.test(val);

// validate external tag
export const validateExternalTag = val => val.length < 255;

// validate value load message
export const validateMessage = mssg => mssg.length < 50;
